import { Injectable } from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {UserConfig} from "app/dar/common/services/user-config/user-config.model";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserConfigService extends DaoGeneric<UserConfig>{
  private url = `${environment.baseUrl}/dar/userconfig/`;
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  getUserCfg(): Observable<UserConfig> {
    const _url = `${this.url}getUserCfg`
    return this.httpClient.get<UserConfig>(_url)
  }
}
